module.exports = __webpack_public_path__ + "img/magento-migration_medium@2x.608eef2b.webp";